import * as React from 'react'

import { observer } from 'mobx-react'

import ConfirmDialog from '~/client/src/shared/components/ConfirmDialog/ConfirmDialog'

interface IProps {
  isShown: boolean
  type: string
  name: string
  onApply(): void
  onHide(): void
  isSaving: boolean
}

@observer
export default class SaveAttributeConfirmDialog extends React.Component<IProps> {
  public render() {
    const { isShown, onHide, onApply, name, isSaving } = this.props

    return (
      <ConfirmDialog
        isOpen={isShown}
        onCancelClicked={onHide}
        onDoneClicked={onApply}
        title={this.title}
        doneTitle="Save"
        loading={isSaving}
      >
        <div>
          <div className="text large mb10">
            Confirm changes of the{' '}
            <span className="text bold large">{name}</span> ?
          </div>
        </div>
      </ConfirmDialog>
    )
  }

  private get title() {
    const { type } = this.props
    return `Confirm changes of ${type}`
  }
}
